<!-- =========================================================================================
    File Name: TheCustomizer.vue
    Description: Template Customizer
    Component Name: TheCustomizer
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="theme-customizer">
    <vx-tooltip class="customizer-btn-vesselBaseStation" text="Base station" position="left">
      <vs-button style="border-top-right-radius: 0;
  border-bottom-right-radius: 0;" @click.stop="active=!active" color="primary" icon-pack="feather" icon="icon-grid"></vs-button>
    </vx-tooltip>
    <vs-sidebar
      hidden-background
      position-right
      v-model="active"
      click-not-close
      class="items-no-padding"
    >
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>List Base station</h4>
          </div>
          <feather-icon icon="XIcon" @click.stop="active = false" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <vs-table
          :sst="true"
          v-model="selected"
          @selected="handleSelected"
          pagination
          max-items="10"
          search
          :data="baseStations"
        >
          <template slot="header"></template>

          <template slot="thead">
            <vs-th sort-key="email">MMSI</vs-th>
            <vs-th sort-key="username">Name</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
              <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from 'axios'
import { API_BASE_URL } from '@/constants'

export default {
  props: {},
  data() {
    return {
      selected: {},
      active: false,
      valueSearch: "",
      baseStations: [],
      accessEmail:'',
      accessToken:''
    };
  },
  mounted() {
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    axios
        .get(
          `${API_BASE_URL}/api/base_stations.json?q[longitude_not_null]=1&q[latitude_not_null]=1`,
          {
            headers: {"X-User-Email":this.accessEmail,"X-User-Token":this.accessToken}
          }
        )
        .then(response => {
          this.baseStations = response.data
        })
        .catch(error => {
          console.log("call apis base station error ", error);
        });
  },
  computed: {},
  methods: {
    handleSelected(tr) {
      this.$vs.notify({
        title: `Selected ${tr.mmsi}`,
        text: `Name: ${tr.name}`
      });
      this.$store.dispatch("updateSelectBaseStation", tr);
    }
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>
<style lang="scss" scoped>
#theme-customizer {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px;
    max-width: 90vw;
  }
}

.customizer-btn-vesselBaseStation {
  position: fixed;
  top: 42%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}

.scroll-area--customizer {
  height: calc(100% - 5rem);
  margin-bottom: 30px;
  border-style: inset;
}

.scroll-area--detail {
  height: 150px;
  border-style: inset;
  padding-left: 10px;
  padding-right: 10px;
}

.vessel-img {
  width: 100%;
  height: 150px;
  border-style: solid gray;
  border-radius: 10px;
  margin-top: 3px;
}
.value-text {
  color: blue;
}
.title-text {
  font-weight: bold;
}

.vs-table--search-input{
  width: 400px;
}
.vs-table--search{
  max-width: none;
}
</style>
